@use '../../../../styles/Constants.scss' as Constants;
@use '../../../../styles/Colors.scss' as Colors;

.Glyph {
	color: Colors.$col-design-grey500;
	line-height: Constants.$val-spacing-m;
	display: inline-block;

	&.icon {
		font-size: Constants.$val-icon16;
	}

	&.symbol {
		font-size: Constants.$val-fontSizeSmall;
	}
}
